var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"whoweare"}},[_c('div',{staticClass:"whoweare-box",domProps:{"innerHTML":_vm._s(_vm.data)}}),_c('Infomation')],1)}
var staticRenderFns = []

export { render, staticRenderFns }